"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var stylable_1 = tslib_1.__importDefault(require("./stylable"));
var View = /** @class */ (function (_super) {
    tslib_1.__extends(View, _super);
    function View() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return View;
}(stylable_1.default));
exports.default = View;
//# sourceMappingURL=view.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/view.js
// module id = 5
// module chunks = 0